import { jsx } from 'react/jsx-runtime';
import { styled } from 'styled-components';
import { IconGlobe } from '@fabric-app/icons/svg';
import { useQueryPageFavicon } from '../queries/useQueryPageFavicon.js';
import { Image } from '@fabric-app/ui/components/Image';

const FaviconImage = ({
  faviconUrl: faviconUrlProp,
  pageUrl,
  className,
  /**
  * you want to load an image bigger that the size rendering - retina displays
  * To control the rendered size pass a classname or use styled components with styled(FaviconImage)
  */
  sizeToLoad = 32,
  PlaceholderIcon,
  style
}) => {
  const { data: faviconUrlFetched } = useQueryPageFavicon({
    url: pageUrl,
    size: sizeToLoad
  }, {
    enabled: !faviconUrlProp
  });
  const faviconUrl = faviconUrlProp || faviconUrlFetched;
  const Placeholder = PlaceholderIcon || IconGlobe;
  return /* @__PURE__ */ jsx(IconImage, {
    src: faviconUrl || void 0,
    alt: "",
    className,
    style,
    children: /* @__PURE__ */ jsx(Placeholder, {
      className
    })
  });
};
const IconImage = styled(Image).withConfig({
  displayName: "FaviconImage__IconImage",
  componentId: "sc-2c5ef7d9-0"
})([
  `background:transparent;border-radius:5px;`
]);

export { FaviconImage };
//# sourceMappingURL=FaviconImage.js.map
